import axios from "axios";
// import store from '@/store'
import { setToken, getToken, localRead } from "@/libs/util";
const qs = require("qs");
import { Message } from "view-design";

let _store;
function getStore() {
  if (!_store) {
    _store = require("@/store").default; // webpack / Vue CLI 等 CommonJS 环境可用
  }
  return _store;
}

// 自定义判断元素类型JS
function toType(obj) {
  return {}.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase();
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null || o[key] === "") {
      delete o[key];
    }
    if (toType(o[key]) === "string") {
      o[key] = o[key].trim();
    } else if (toType(o[key]) === "object") {
      o[key] = filterNull(o[key]);
    } else if (toType(o[key]) === "array") {
      o[key] = filterNull(o[key]);
    }
  }
  return o;
}
const addErrorLog = errorInfo => {
  const {
    statusText,
    status,
    request: { responseURL }
  } = errorInfo;
  let info = {
    type: "ajax",
    code: status,
    mes: statusText,
    url: responseURL
  };
  if (!responseURL.includes("save_error_logger"))
    getStore().dispatch("addErrorLog", info);
};

class HttpRequest {
  constructor(baseUrl = baseURL) {
    this.baseUrl = baseUrl;
    this.queue = {};
  }
  getInsideConfig(contentType) {
    let ct = {
      "Content-Type": "application/json"
    };
    if (contentType == "FormData") {
      ct["Content-Type"] = "multipart/form-data;";
    } else if (contentType == "form") {
      ct["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8";
    }
    if (getToken()) {
      ct["Authorization"] = getToken();
    }
    let local = localRead("local");
    if (local === "zh-CN") {
      ct["Accept-Language"] = "zh";
    } else if (local === "en-US") {
      ct["Accept-Language"] = "en";
    }
    const config = {
      baseURL: this.baseUrl,
      headers: {
        ...ct
      },
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      }
    };
    return config;
  }
  destroy(url) {
    delete this.queue[url];
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(
      config => {
        //过滤参数
        if (config.data) {
          config.data = filterNull(config.data);
        }
        // 添加全局的loading...
        if (!Object.keys(this.queue).length) {
          // Spin.show() // 不建议开启，因为界面不友好
        }
        this.queue[url] = true;
        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );
    // 响应拦截
    instance.interceptors.response.use(
      res => {
        this.destroy(url);
        const { data, status } = res;
        //登录过期，重新登录
        if (data.result === 107 || data.result === 812 || data.result === 813) {
          //删除 session状态，跳转登录页面
          setToken("");
          //Modal.remove();
          // setTimeout(function(){
          //   Modal.success({
          //     title:'登录过期',
          //     content:'登录过期，请求重新登录',
          //     onOk:function(){
          //       location.reload();
          //     }
          //   });
          // },1000)
          Message.error({
            duration: 3,
            content: "登录过期，请求重新登录",
            onClose: () => {
              location.reload();
            }
          });
        }
        return { ...data };
      },
      error => {
        this.destroy(url);
        let errorInfo = error.response;
        if (!errorInfo) {
          const {
            request: { statusText, status },
            config
          } = JSON.parse(JSON.stringify(error));
          errorInfo = {
            statusText,
            status,
            request: { responseURL: config.url }
          };
        }
        addErrorLog(errorInfo);
        return Promise.reject(error);
      }
    );
  }
  request(options, contentType) {
    const instance = axios.create();
    options = Object.assign(this.getInsideConfig(contentType), options);
    this.interceptors(instance, options.url);
    return instance(options);
  }
}
export default HttpRequest;
